export default "__VITE_ASSET__BNJV4_$l__"